import type { ThemeConfig } from "antd";
import { theme } from "antd";

/**
 * Light theme: clean blue primary palette on white background.
 * Matches professional financial dashboard conventions.
 */
export const lightTheme: ThemeConfig = {
  algorithm: theme.defaultAlgorithm,
  token: {
    // Brand color
    colorPrimary: "#1677ff",
    colorLink: "#1677ff",

    // Layout
    colorBgBase: "#ffffff",
    colorBgContainer: "#ffffff",
    colorBgLayout: "#f0f2f5",
    colorBgElevated: "#ffffff",

    // Text
    colorText: "#1c1c1e",
    colorTextSecondary: "#5f6368",
    colorTextTertiary: "#8c8c8c",

    // Border
    colorBorder: "#d9d9d9",
    colorBorderSecondary: "#f0f0f0",

    // Feedback
    colorSuccess: "#52c41a",
    colorWarning: "#faad14",
    colorError: "#ff4d4f",
    colorInfo: "#1677ff",

    // Typography
    fontFamily:
      "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    fontSize: 14,
    borderRadius: 8,

    // Sizing
    controlHeight: 36,
  },
  components: {
    Layout: {
      siderBg: "#001529",
      headerBg: "#ffffff",
      headerHeight: 64,
    },
    Menu: {
      darkItemBg: "#001529",
      darkItemSelectedBg: "#1677ff",
      darkItemColor: "rgba(255,255,255,0.65)",
      darkItemSelectedColor: "#ffffff",
    },
    Card: {
      boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
    },
  },
};

/**
 * Dark theme: dark backgrounds with blue accents.
 * Reduces eye strain for extended financial analysis sessions.
 */
export const darkTheme: ThemeConfig = {
  algorithm: theme.darkAlgorithm,
  token: {
    // Brand color — slightly lighter for dark background contrast
    colorPrimary: "#4096ff",
    colorLink: "#4096ff",

    // Layout
    colorBgBase: "#141414",
    colorBgContainer: "#1e1e1e",
    colorBgLayout: "#0d0d0d",
    colorBgElevated: "#252525",

    // Text
    colorText: "#e6e6e6",
    colorTextSecondary: "#a6a6a6",
    colorTextTertiary: "#595959",

    // Border
    colorBorder: "#303030",
    colorBorderSecondary: "#1f1f1f",

    // Feedback
    colorSuccess: "#49aa19",
    colorWarning: "#d89614",
    colorError: "#dc4446",
    colorInfo: "#4096ff",

    // Typography
    fontFamily:
      "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    fontSize: 14,
    borderRadius: 8,

    // Sizing
    controlHeight: 36,
  },
  components: {
    Layout: {
      siderBg: "#0d0d0d",
      headerBg: "#1e1e1e",
      headerHeight: 64,
    },
    Menu: {
      darkItemBg: "#0d0d0d",
      darkItemSelectedBg: "#4096ff",
      darkItemColor: "rgba(255,255,255,0.55)",
      darkItemSelectedColor: "#ffffff",
    },
    Card: {
      boxShadow: "0 1px 4px rgba(0,0,0,0.4)",
    },
  },
};
